import { PRODUCT_TYPES } from '../utils/product/constants'

export const DATASHEET_COMPONENTS = {
  APPLICATIONS_KEY: 'ApplicationsKey',
  BACKGROUND: 'Background',
  BACKGROUND_REFERENCES: 'BackgroundReferences',
  BIOACTIVITY: 'Bioactivity',
  CAS_NUMBER: 'CasNumber',
  COMPANION_PRODUCTS: 'CompanionProducts',
  CROSS_REACTIVITY_KEY: 'CrossReactivityKey',
  DATASHEET_TABLE: 'DatasheetTable',
  DESCRIPTION: 'Description',
  DIRECTIONS_FOR_USE: 'DirectionsForUse',
  ENDOTOXIN: 'Endotoxin',
  FORMULATION: 'Formulation',
  HEADER: 'Header',
  HOMOLOGIES: 'Homologies',
  LIMITED_USES: 'LimitedUses',
  MOLECULAR_FORMULA: 'MolecularFormula',
  MOLECULAR_WEIGHT: 'MolecularWeight',
  PRODUCT_INCLUDES: 'ProductIncludes',
  PRODUCT_USAGE_INFORMATION: 'ProductUsageInformation',
  PURITY: 'Purity',
  REAGENTS_NOT_INCLUDED: 'ReagentsNotIncluded',
  RESEARCH_USE_ONLY: 'ResearchUseOnly',
  SOLUBILITY: 'Solubility',
  SOLUTIONS_REAGENTS: 'SolutionsReagents',
  SOURCE_OR_PURIFICATION: 'SourceOrPurification',
  SPECIES_REACTIVITY: 'SpeciesReactivity',
  SPECIFICITY_SENSITIVITY: 'SpecificitySensitivity',
  STORAGE: 'Storage',
  SUPPORTING_DATA: 'SupportingData',
  TRADEMARKS_AND_PATENTS: 'TrademarksAndPatents',
} as const

export const USAGE_INFORMATION_COMPONENTS = {
  GROWTH_FACTORS_AND_CYTOKINES: [
    DATASHEET_COMPONENTS.BACKGROUND,
    DATASHEET_COMPONENTS.ENDOTOXIN,
    DATASHEET_COMPONENTS.PURITY,
    DATASHEET_COMPONENTS.SOURCE_OR_PURIFICATION,
    DATASHEET_COMPONENTS.BIOACTIVITY,
    DATASHEET_COMPONENTS.BACKGROUND_REFERENCES,
  ],
  CHEMICAL_MODULATORS: [
    DATASHEET_COMPONENTS.BACKGROUND,
    DATASHEET_COMPONENTS.DESCRIPTION,
    DATASHEET_COMPONENTS.MOLECULAR_FORMULA,
    DATASHEET_COMPONENTS.MOLECULAR_WEIGHT,
    DATASHEET_COMPONENTS.PURITY,
    DATASHEET_COMPONENTS.CAS_NUMBER,
    DATASHEET_COMPONENTS.SOLUBILITY,
    DATASHEET_COMPONENTS.STORAGE,
    DATASHEET_COMPONENTS.DIRECTIONS_FOR_USE,
    DATASHEET_COMPONENTS.BACKGROUND_REFERENCES,
  ],
  ANTIBODY_DUET__ANTIBODY_SAMPLER_KIT: [
    DATASHEET_COMPONENTS.DESCRIPTION,
    DATASHEET_COMPONENTS.STORAGE,
    DATASHEET_COMPONENTS.BACKGROUND,
    DATASHEET_COMPONENTS.BACKGROUND_REFERENCES,
  ],
  ELISA_KIT__FAST_SCAN_ELISA_KIT: [
    DATASHEET_COMPONENTS.DESCRIPTION,
    DATASHEET_COMPONENTS.SPECIFICITY_SENSITIVITY,
    DATASHEET_COMPONENTS.BACKGROUND,
    DATASHEET_COMPONENTS.BACKGROUND_REFERENCES,
  ],
  ELISA_ANTIBODY_PAIR: [
    DATASHEET_COMPONENTS.DESCRIPTION,
    DATASHEET_COMPONENTS.REAGENTS_NOT_INCLUDED,
    DATASHEET_COMPONENTS.BACKGROUND,
    DATASHEET_COMPONENTS.BACKGROUND_REFERENCES,
  ],
  OLIGO_ANTIBODY_PAIR: [
    DATASHEET_COMPONENTS.STORAGE,
    DATASHEET_COMPONENTS.DESCRIPTION,
    DATASHEET_COMPONENTS.SPECIFICITY_SENSITIVITY,
    DATASHEET_COMPONENTS.SOURCE_OR_PURIFICATION,
    DATASHEET_COMPONENTS.BACKGROUND,
    DATASHEET_COMPONENTS.BACKGROUND_REFERENCES,
  ],
  SIGNALSTAR_SECONDARY_ANTIBODY_KIT: [
    DATASHEET_COMPONENTS.STORAGE,
    DATASHEET_COMPONENTS.DESCRIPTION,
    DATASHEET_COMPONENTS.SPECIFICITY_SENSITIVITY,
  ],
  MATCHED_ANTIBODY_PAIR: [
    DATASHEET_COMPONENTS.DESCRIPTION,
    DATASHEET_COMPONENTS.SPECIFICITY_SENSITIVITY,
    DATASHEET_COMPONENTS.STORAGE,
    DATASHEET_COMPONENTS.DIRECTIONS_FOR_USE,
    DATASHEET_COMPONENTS.FORMULATION,
    DATASHEET_COMPONENTS.BACKGROUND,
    DATASHEET_COMPONENTS.BACKGROUND_REFERENCES,
  ],
  PROTEIN_CONTROL: [
    DATASHEET_COMPONENTS.DESCRIPTION,
    DATASHEET_COMPONENTS.FORMULATION,
    DATASHEET_COMPONENTS.MOLECULAR_WEIGHT,
    DATASHEET_COMPONENTS.STORAGE,
    DATASHEET_COMPONENTS.PURITY,
    DATASHEET_COMPONENTS.BACKGROUND,
    DATASHEET_COMPONENTS.BACKGROUND_REFERENCES,
  ],
  CELLULAR_DYES: [
    DATASHEET_COMPONENTS.DESCRIPTION,
    DATASHEET_COMPONENTS.STORAGE,
    DATASHEET_COMPONENTS.DIRECTIONS_FOR_USE,
  ],
  CELL_EXTRACTS: [
    DATASHEET_COMPONENTS.DESCRIPTION,
    DATASHEET_COMPONENTS.STORAGE,
    DATASHEET_COMPONENTS.BACKGROUND,
    DATASHEET_COMPONENTS.DIRECTIONS_FOR_USE,
    DATASHEET_COMPONENTS.BACKGROUND_REFERENCES,
  ],
  DETECTION_SYSTEM: [
    DATASHEET_COMPONENTS.DESCRIPTION,
    DATASHEET_COMPONENTS.STORAGE,
    DATASHEET_COMPONENTS.BACKGROUND,
    DATASHEET_COMPONENTS.DIRECTIONS_FOR_USE,
    DATASHEET_COMPONENTS.SOLUTIONS_REAGENTS,
    DATASHEET_COMPONENTS.REAGENTS_NOT_INCLUDED,
    DATASHEET_COMPONENTS.COMPANION_PRODUCTS,
  ],
  DETECTION_SYSTEM_KIT: [
    DATASHEET_COMPONENTS.DESCRIPTION,
    DATASHEET_COMPONENTS.STORAGE,
    DATASHEET_COMPONENTS.BACKGROUND,
    DATASHEET_COMPONENTS.DIRECTIONS_FOR_USE,
    DATASHEET_COMPONENTS.SOLUTIONS_REAGENTS,
    DATASHEET_COMPONENTS.BACKGROUND_REFERENCES,
  ],
  MW_MARKER_KIT: [
    DATASHEET_COMPONENTS.DESCRIPTION,
    DATASHEET_COMPONENTS.STORAGE,
    DATASHEET_COMPONENTS.SPECIFICITY_SENSITIVITY,
    DATASHEET_COMPONENTS.SOURCE_OR_PURIFICATION,
    DATASHEET_COMPONENTS.BACKGROUND,
    DATASHEET_COMPONENTS.DIRECTIONS_FOR_USE,
    DATASHEET_COMPONENTS.SOLUTIONS_REAGENTS,
    DATASHEET_COMPONENTS.BACKGROUND_REFERENCES,
  ],
  DEFAULT: [
    DATASHEET_COMPONENTS.PRODUCT_USAGE_INFORMATION,
    DATASHEET_COMPONENTS.SPECIFICITY_SENSITIVITY,
    DATASHEET_COMPONENTS.HOMOLOGIES,
    DATASHEET_COMPONENTS.SOURCE_OR_PURIFICATION,
    DATASHEET_COMPONENTS.DESCRIPTION,
    DATASHEET_COMPONENTS.BACKGROUND,
    DATASHEET_COMPONENTS.BACKGROUND_REFERENCES,
  ],
}

export const doNotShowSupportingData = [
  PRODUCT_TYPES.CHEMICAL_MODULATORS,
  PRODUCT_TYPES.ELISA_ANTIBODY_PAIR,
  PRODUCT_TYPES.ANTIBODY_SAMPLER_KIT,
  PRODUCT_TYPES.MATCHED_ANTIBODY_PAIR,
  PRODUCT_TYPES.ELISA_KIT,
  PRODUCT_TYPES.FAST_SCAN_ELISA_KIT,
  PRODUCT_TYPES.OLIGO_ANTIBODY_PAIR,
  PRODUCT_TYPES.CELL_EXTRACTS,
  PRODUCT_TYPES.CELL_EXTRACT_KIT,
  PRODUCT_TYPES.DETECTION_SYSTEM,
  PRODUCT_TYPES.DETECTION_SYSTEM_KIT,
  PRODUCT_TYPES.MW_MARKER,
  PRODUCT_TYPES.MW_MARKER_KIT,
  PRODUCT_TYPES.PROTEIN_CONTROL,
  PRODUCT_TYPES.PROTEIN_CONTROL_KIT,
  PRODUCT_TYPES.PTM_SCAN,
  PRODUCT_TYPES.CELLULAR_DYES,
]

export const pageSizes = {
  a4: {
    width: 8.27,
    height: 11.5,
  },
  letter: {
    width: 8.5,
    height: 11,
  },
} as const

export const datasheetPrintMargins = {
  width: 0.5,
  height: 0.52,
} as const

export const pageContentSize = {
  a4: {
    width: pageSizes.a4.width - datasheetPrintMargins.width * 2,
    height: pageSizes.a4.height - datasheetPrintMargins.height * 2,
  },
  letter: {
    width: pageSizes.letter.width - datasheetPrintMargins.width * 2,
    height: pageSizes.letter.height - datasheetPrintMargins.height * 2,
  },
} as const

export const pixelsPerInch = 96 as const
